import React from 'react'
import { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { EMPLOYER_URL } from '../../../resources/resource';
import { useFetchData } from '../../../hooks/useFtechData';
import { useSelector } from 'react-redux';
import ProfileCard from '../Profile';
import ProfileForm from '../ProfileForm';
import ProofSection from '../ProofAddress';
import FaceAuthentication from './FaceAuthentication';
import EmployerVerificationForm from './EmployerVerificationForm';

const Profile = () => {
     const currentUser = useSelector((state) => state.user.currentUser);
      // console.log('user current', currentUser)
      const { data, refetch } = useFetchData(
        EMPLOYER_URL + `/getJobEmployer/${currentUser?._id}`
      );
      const navigate = useNavigate();
    
      ///state for employee details
        const [employeeDetails, setEmployeeDetails] = useState([]);
      const [loading, setLoading] = useState(true);


      useEffect(() => {
          const fetchEmployeeDetails = async () => {
            if (data?.employers) {
              try {
                const details = await Promise.all(
                  data.employers.map(async (id) => {
                    // Replace with your actual API call to get employee details by ID
                    const response = await fetch(`${EMPLOYER_URL}/getEmployeeDetails/${id}`);
                    const empData = await response.json();
                    return { id, name: empData.name || `Employee ${id}` }; // Adjust based on API response
                  })
                );
                setEmployeeDetails(details);
              } catch (error) {
                console.error('Error fetching employee details:', error);
              } finally {
                setLoading(false);
              }
            } else {
              setLoading(false);
            }
          };
          fetchEmployeeDetails();
        }, [data, EMPLOYER_URL]);

        
  const handleChangeProfile = () => {};
  return (
    <div>

    <ProfileCard user={data} refetch={refetch}  />
      <div className="bg-white shadow-sm rounded-lg p-6">
                <h2 className="text-lg font-semibold text-gray-900 mb-6">
                  Company Profile
                </h2>
             
                <ProfileForm
                  user={currentUser}
                  onInputChange={handleChangeProfile}
                />
              </div>
              {/* <FaceAuthentication/> */}
              <EmployerVerificationForm/>
              <ProofSection
                title="Proof of Address"
            proofs={data?.proofOfCompany}
            refetch={refetch}
            />
 
      
    </div>
  )
}

export default Profile
